import type { FC, ReactNode } from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

interface ConfirmModalProps {
  title: string;
  show: boolean;
  body: ReactNode;
  handleCancel: () => void;
  handleConfirm: () => void;
  isGuestPortal?: boolean;
}

export interface ModalState {
  title: string;
  show: boolean;
  body: ReactNode;
  handler?: () => void;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
  title,
  show,
  body,
  handleCancel,
  handleConfirm,
  isGuestPortal = false,
}) => {
  if (isGuestPortal) {
    return (
      <Modal
        show={show}
        onHide={handleCancel}
        dialogClassName="post-editor-modal modal-100w"
        backdrop="static"
        id="guest-portal"
        centered
      >
        <Modal.Header className="guest-modal-header">
          <Modal.Title className="editor-title">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="guest-modal-header">
          <Form>
            <Row>
              <Form.Text style={{ color: 'var(--primary-font-color)' }}>{body}</Form.Text>
            </Row>
          </Form>
        </Modal.Body>
        <Container className="guest-modal-footer">
          <Button className="cancel-button no-border-radius" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            className="save-button no-border-radius"
            onClick={() => {
              handleConfirm();
            }}
          >
            Confirm
          </Button>
        </Container>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={handleCancel} dialogClassName="post-editor-modal">
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-content">{body}</Modal.Body>
      <Modal.Footer>
        <Button className="cancel-button" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          className="save-button"
          onClick={() => {
            handleConfirm();
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
